<template>
<div>
  <button id="change_points" @click="changePoints('Rice')">Rice</button>
  <button id="change_points" @click="changePoints('Cassava')">Cassava</button>
  <button id="change_points" @click="changePoints('Vegetables')">Vegetables</button>
</div>
</template>
<script>

export default {

  data () {
    return {

    }
  }
}
</script>
<style scoped>

</style>
